module.exports = __webpack_public_path__ + "media/images/athletes/4344-f8fd391868ff8ff20b8085a54bbc5199.png";